export default "__VITE_PUBLIC_ASSET__89493cb1__"